import React, { Dispatch, ReactElement, ReactNode, createContext, useContext, useEffect, useReducer, useRef } from "react"

var id = 1;

export interface Toast{
    id?: number
    style?: string
    body: ReactNode
}

interface ToastState{
    toasts: Toast[]
}

type Action = 
    {type: 'addToast', payload: Toast} |
    {type: 'removeToast', payload: number}

export const ToastContext = createContext<{state: ToastState; dispatch?: Dispatch<Action> }>({state: {toasts:[]}});


function reducer(state:ToastState, action: Action):ToastState{
    switch(action.type){
        case 'addToast': return {...state, toasts: [...state.toasts, action.payload]};
        case 'removeToast': return {...state, toasts: state.toasts.filter(d => d.id != action.payload)};
        default: return state;
    }
}


function ToastItem({toast}:{toast:Toast}){
    const ref = useRef<HTMLDivElement>();
    const {dispatch} = useContext(ToastContext);
    
    useEffect(() =>  {
        var element = window.bootstrap.Toast.getOrCreateInstance(ref.current);
        element.show();
        ref.current.addEventListener('hidden.bs.toast', function () {
            dispatch({type: 'removeToast', payload: toast.id});
        })     
    }, []);

    return <div ref={ref} className={`toast align-items-center text-white ${toast.style || 'bg-primary'} border-0`} data-bs-delay="3000" role="alert" aria-live="assertive" aria-atomic="true">
        <div className="d-flex">
            <div className="toast-body">
                {toast.body}
            </div>
            <button type="button" className="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
        </div>
    </div>
}

declare global {
    interface Window {
        bootstrap?:any
    }
}

export function ToastStore({children}:{children:ReactNode}){
    const[state, dispatch] = useReducer(reducer, {toasts:[]})

    return <ToastContext.Provider value={{state, dispatch}}>
        {children}
        <div className="toast-container position-fixed p-3 bottom-0 end-0" style={{zIndex: 1080}}>
            {state.toasts.map(t => <ToastItem key={t.id} toast={t} />)}
        </div>
    </ToastContext.Provider>
}


export function useAddToast(){
    const {dispatch} = useContext(ToastContext);
    return (title:ReactNode, style = "bg-primary") => {
        dispatch({type: "addToast", payload: {id: id++, body:title, style: style} });
    }
}
